module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "content-icons-ui": "static-1.2417"
    },
    "depPathPrefixes": {
      "content-icons-ui": "/content-icons-ui/static-1.2417"
    },
    "bundlingPackage": "LearningCenterUI",
    "bundlingPackageVersion": "static-1.34901",
    "project": "content-icons-ui",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};